import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { appDefaultLanguageCode, getSupportedLanguageCodes } from 'Consts/language';
import { isNotProductionEnvironment } from 'Utils/environments';

const SUPPORTED_LANGUAGES = getSupportedLanguageCodes();
const ALL_SUPPORTED_LANGUAGES = [...SUPPORTED_LANGUAGES, 'en', 'pl'];

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: appDefaultLanguageCode,
    fallbackLng: appDefaultLanguageCode,
    debug: isNotProductionEnvironment(),
    supportedLngs: ALL_SUPPORTED_LANGUAGES,
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode']
    },
    backend: {
      loadPath: (lngs: string[], namespaces: string[]) => {
        const lng = lngs[0];
        const ns = namespaces[0];

        const languageMap: Record<string, string> = {
          en: 'en-US',
          pl: 'pl-PL'
        };

        const mappedLng = languageMap[lng] || lng;
        return `/locales/${mappedLng}/${ns}.json`;
      },
      requestOptions: {
        cache: 'default',
        credentials: 'same-origin',
        mode: 'cors'
      }
    },

    interpolation: {
      escapeValue: false
    },
    saveMissing: isNotProductionEnvironment(),
    missingKeyHandler: (lng, ns, key) => {
      if (isNotProductionEnvironment()) {
        console.warn(`Missing translation key: ${key} for language: ${lng}`);
      }
    }
  });

export default i18next;
